<!--
 * @Description: 表单设计器内容展示操作组件
 * @Author: kcz
 * @Date: 2019-12-31 19:39:48
 * @LastEditors: kcz
 * @LastEditTime: 2022-11-12 00:11:55
 -->
<template>
  <div class="form-panel">
    <p class="hint-text" v-show="data.list.length === 0">
      <a-empty description="从左侧选择控件添加" />
    </p>
    <a-form
      class="a-form-box k-form-build"
      :form="form"
      selfUpdate
      :layout="data.config.layout"
      :hideRequiredMark="data.config.hideRequiredMark"
      :style="data.config.customStyle"
    >
      <draggable
        tag="div"
        class="draggable-box"
        v-bind="{
          group: 'form-draggable',
          ghostClass: 'moving',
          animation: 180,
          handle: '.drag-move'
        }"
        :disabled="isDraDisabled"
        v-model="data.list"
        @add="deepClone"
        @start="dragStart($event, data.list)"
        @change="dragChange($event, data.list)"
      >
        <transition-group tag="div" name="list" class="list-main">
          <layoutItem
            class="drag-move"
            v-for="record in data.list"
            :key="record.key"
            :record="record"
            :config="data.config"
            :selectItem.sync="selectItem"
            :startType="startType"
            :insertAllowedType="insertAllowedType"
            :hideModel="hideModel"
            :hideTypeModel="hideTypeModel"
            :selectForm="selectForm"
            @dragStart="dragStart"
            @handleSelectItem="handleSelectItem"
            @handleCopy="handleCopy"
            @handleDelete="handleDelete"
            @handleRelation="handleRelation"
            @handleColAdd="handleColAdd"
            @handleColReplace="handleColReplace"
            @handleShowRightMenu="handleShowRightMenu"
            @refreshOptions="refreshOptions"
          />
        </transition-group>
      </draggable>
    </a-form>
    <!-- 右键菜单 start -->
    <div
      v-show="showRightMenu"
      :style="{ top: menuTop + 'px', left: menuLeft + 'px' }"
      class="right-menu"
    >
      <ul>
        <li @click="handleDownMerge"><a-icon type="caret-down" />向下合并</li>
        <li @click="handleRightMerge"><a-icon type="caret-right" />向右合并</li>
        <li @click="handleCancelMerge">
          <a-icon type="border-inner" />取消合并
        </li>
        <li @click="handleAddCol">
          <a-icon type="border-horizontal" />增加一列
        </li>
        <li @click="handleAddRow"><a-icon type="border-verticle" />增加一行</li>
        <li @click="handleDelCol">
          <a-icon type="delete" />删除一列
        </li>
        <li @click="handleDelRow"><a-icon type="delete" />删除一行</li>
      </ul>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import layoutItem from "./layoutItem";
import { message } from "ant-design-vue";
import { eraseUtils } from "../../../utils/index";
 import {  mapGetters } from 'vuex'
export default {
  name: "KCenter",
  data() {
    return {
      form: this.$form.createForm(this),
      insertAllowedType: [
        "input",
        "textarea",
        "number",
        "knumber",
        "select",
        "checkbox",
        "radio",
        "date",
        "time",
        "rate",
        "slider",
        "uploadFile",
        "uploadImg",
        "cascader",
        "treeSelect",
        "switch",
        "text",
        "html",
        "table"
      ],
      rightMenuSelectValue: {},
      showRightMenu: false,
      menuTop: 0,
      menuLeft: 0,
      trIndex: 0,
      tdIndex: 0
    };
  },
  props: {
    noModel: {
      type: Array,
      required: true
    },
    startType: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    selectItem: {
      type: Object,
      default: () => {}
    },
    hideModel: {
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      type: Boolean,
      default: false
    },
    selectForm: {
      type: Object,
      default: () => {}
    }
  },
  computed: { 
    isDraDisabled() { 
      // 修复：确保正确处理isDisable状态，防止拖拽功能失效
      try {
        return this.$store.getters.isDisable || false;
      } catch (e) {
        // 如果获取状态失败，默认不禁用拖拽
        return false;
      }
    }
  },
  components: {
    draggable,
    layoutItem
  },
  methods: {
    deepClone(evt) {
      const newIndex = evt.newIndex;
      // json深拷贝一次
      const listString = JSON.stringify(this.data.list);
      this.data.list = JSON.parse(listString);
      // 删除icon及compoent属性
      delete this.data.list[newIndex].icon;
      delete this.data.list[newIndex].component;
      
      // 自动计算序号并设置
      this.data.list[newIndex].sequence = (newIndex + 1).toString();
      
      // 确保common对象存在并设置sortNum
      if (!this.data.list[newIndex].common) {
        this.data.list[newIndex].common = {};
      }
      this.data.list[newIndex].common.sortNum = newIndex + 1;
      
      // 重新排序所有项目的序号
      this.updateSequenceNumbers();
      
      this.$emit("handleSetSelectItem", this.data.list[newIndex]);
    },
    
    // 更新所有项目的序号
    updateSequenceNumbers() {
      const items = this.data.list;
      
      // 创建映射表，提高查找效率
      const codeToItemMap = new Map();     // 题目code到题目的映射
      const codeToIndexMap = new Map();    // 题目code到列表索引的映射
      const codeToChildrenMap = new Map(); // 父题code到子题列表的映射
      
      // 构建映射表
      items.forEach((item, index) => {
        // 确保item有common属性
        if (!item.common) {
          item.common = {};
        }
        
        const code = this.getItemCode(item);
        if (code) {
          codeToItemMap.set(code, item);
          codeToIndexMap.set(code, index);
        }
        
        // 构建父子关系映射
        const parentCode = this.getItemParentCode(item);
        if (parentCode) {
          if (!codeToChildrenMap.has(parentCode)) {
            codeToChildrenMap.set(parentCode, []);
          }
          // 按子题在原始列表中的顺序添加
          codeToChildrenMap.get(parentCode).push(item);
        }
      });
      
      // 生成层级序号
      this.generateHierarchicalSequence(items, codeToChildrenMap, codeToIndexMap);
    },
    
    // 生成层级序号
    generateHierarchicalSequence(items, codeToChildrenMap, codeToIndexMap) {
      // 按在列表中的顺序处理所有题目，确保顶级题目先处理
      let topLevelIndex = 0;
      
      items.forEach((item) => {
        // 检查item是否有common属性
        if (!item.common) {
          item.common = {};
        }
        
        const parentCode = this.getItemParentCode(item);
        
        if (!parentCode) {
          // 顶级题目，使用顺序索引作为基础序号，并添加题标"."
          const baseSequence = (topLevelIndex + 1).toString() + '.';
          this.setItemSequence(item, baseSequence, topLevelIndex + 1);
          topLevelIndex++;
          
          // 递归生成该顶级题目的所有子题序号
          this.generateChildSequence(item, baseSequence, codeToChildrenMap, codeToIndexMap);
        } else {
          // 子题的sortNum由其父题决定，这里不需要单独设置
        }
      });
    },
    
    // 递归生成子题序号
    generateChildSequence(parentItem, parentSequence, codeToChildrenMap, codeToIndexMap) {
      const parentCode = this.getItemCode(parentItem);
      if (!parentCode || !codeToChildrenMap.has(parentCode)) {
        return; // 没有子题，直接返回
      }
      
      // 获取当前父题的所有直接子题
      const directChildren = codeToChildrenMap.get(parentCode);
      
      // 为每个直接子题设置序号
      directChildren.forEach((childItem, childIndex) => {
        // 确保子题有common属性
        if (!childItem.common) {
          childItem.common = {};
        }
        
        // 生成子题序号（父题序号 + . + 子题索引）
        // 处理父题序号可能已经以点结尾的情况，避免出现多个点
        let childSequence;
        if (parentSequence.endsWith('.')) {
          // 如果父题序号已经以点结尾，直接添加子题索引
          childSequence = `${parentSequence}${childIndex + 1}`;
        } else {
          // 如果父题序号不以点结尾，添加点和子题索引
          childSequence = `${parentSequence}.${childIndex + 1}`;
        }
        
        // 获取子题在原始列表中的位置，用于设置sortNum
        const childIndexInList = codeToIndexMap.get(this.getItemCode(childItem)) || 0;
        
        // 设置子题序号
        this.setItemSequence(childItem, childSequence, childIndexInList + 1);
        
        // 递归处理当前子题的所有子题
        this.generateChildSequence(childItem, childSequence, codeToChildrenMap, codeToIndexMap);
      });
    },
    
    // 获取题目的parentCode
    getItemParentCode(item) {
      return item.common && item.common.parentCode;
    },
    
    // 获取题目的code
    getItemCode(item) {
      return item.common && item.common.code;
    },
    
    // 设置题目的序号
    setItemSequence(item, sequence, sortNum) {
      item.sequence = sequence;
      if (!item.common) {
        item.common = {};
      }
      item.common.sortNum = sortNum;
    },
    handleColAdd(evt, columns, isCopy = false) {
      this.handleColAddBase(evt, columns, isCopy, false)
    },
    handleColReplace(evt, columns, callback) {
      this.handleColAddBase(evt, columns, false, true, callback)
    },
    handleColAddBase(evt, columns, isCopy = false, isReplace = false, callback) {
      if (isReplace) {
        let newIndex = evt.newIndex;

        let currentColumns = columns[newIndex];
        if (!currentColumns) {
          newIndex--;
        }

        const key = columns[newIndex].type + "_" + new Date().getTime();
        
        if (columns[newIndex].key === "") {
          this.$set(columns, newIndex, {
            ...columns[newIndex],
            key,
            model: key,
            common: {
              code: eraseUtils.generateShortId()
            }
          });
        }

        const listString = JSON.stringify(columns[newIndex]);

        columns = [];
        columns[0] = JSON.parse(listString);
        this.$emit("handleSetSelectItem", columns[0]);
        
        // 重新排序所有项目的序号
        this.updateSequenceNumbers();

        if (callback) {
          this.$nextTick(()=>{
                callback(columns);
          })
        }
      } else {
        // 重置或者生成key值
        let newIndex = evt.newIndex;

        let currentColumns = columns[newIndex];
        if (!currentColumns) {
          newIndex--;
        }

        const key = columns[newIndex].type + "_" + new Date().getTime();
        if (columns[newIndex].key === "" || isCopy) {
          this.$set(columns, newIndex, {
            ...columns[newIndex],
            key,
            model: key,
            common: {
              code: eraseUtils.generateShortId()
            }
          });
          if (this.noModel.includes(columns[newIndex].type)) {
            // 删除不需要的model属性
            delete columns[newIndex].model;
          }
          if (typeof columns[newIndex].options !== "undefined") {
            // 深拷贝options
            const optionsStr = JSON.stringify(columns[newIndex].options);
            columns[newIndex].options = JSON.parse(optionsStr);
          }
          if (typeof columns[newIndex].rules !== "undefined") {
            // 深拷贝rules
            const rulesStr = JSON.stringify(columns[newIndex].rules);
            columns[newIndex].rules = JSON.parse(rulesStr);
          }
          if (typeof columns[newIndex].list !== "undefined") {
            // 深拷贝list
            columns[newIndex].list = [];
          }
          if (typeof columns[newIndex].columns !== "undefined") {
            // 深拷贝columns
            const columnsStr = JSON.stringify(columns[newIndex].columns);
            columns[newIndex].columns = JSON.parse(columnsStr);
            // 复制时，清空数据
            columns[newIndex].columns.forEach(item => {
              item.list = [];
            });
          }
          if (columns[newIndex].type === "table") {
            // 深拷贝trs
            const trsStr = JSON.stringify(columns[newIndex].trs);
            columns[newIndex].trs = JSON.parse(trsStr);
            // 复制时，清空数据
            columns[newIndex].trs.forEach(item => {
              item.tds.forEach(val => {
                val.list = [];
              });
            });
          }
        }
        // 深拷贝数据
        const listString = JSON.stringify(columns[newIndex]);
        columns[newIndex] = JSON.parse(listString);
        this.$emit("handleSetSelectItem", columns[newIndex]);
        
        // 重新排序所有项目的序号
        this.updateSequenceNumbers();
      }

      return columns;
    },
    dragStart(evt, list) {
      // 拖拽开始,自动选择拖拽的控件项
      this.$emit("handleSetSelectItem", list[evt.oldIndex]);
    },
    
    dragChange(evt, list) {
      // 拖拽完成并排序后，重新排序所有项目的序号
      this.updateSequenceNumbers();
      
      // 如果有移动的元素，确保选中正确的项目
      if (evt.moved) {
        this.$emit("handleSetSelectItem", list[evt.moved.newIndex]);
      }
    },
    handleSelectItem(record) {
      // 修改选择Item
      this.$emit("handleSetSelectItem", record);
    },
    handleCopy(isCopy = true, data) {
      const traverse = array => {
        array.forEach((element, index) => {
          if (element.key === this.selectItem.key) {
            if (isCopy) {
              // 复制添加到选择节点后面
              array.splice(index + 1, 0, element);
            } else {
              // 双击添加到选择节点后面
              array.splice(index + 1, 0, data);
            }
            // 复制完成，重置key值
            const evt = {
              newIndex: index + 1
            };
            this.handleColAdd(evt, array, true);
            
            // 重新排序所有项目的序号
            this.updateSequenceNumbers();
            return;
          }
          if (["grid", "tabs", "selectInputList"].includes(element.type)) {
            // 栅格布局
            element.columns.forEach(item => {
              traverse(item.list);
            });
          } else if (element.type === "card" || element.type === 'selectCard' || element.type === 'emptyCard') {
            // 卡片布局
            traverse(element.list);
          } else if (element.type === "batch") {
            // 动态表格内复制
            if (!isCopy && !this.insertAllowedType.includes(data.type)) {
              // 插入不允许的字段时，直接return false
              return false;
            }
            traverse(element.list);
          }
          if (element.type === "table") {
            // 表格布局
            element.trs.forEach(item => {
              item.tds.forEach(val => {
                traverse(val.list);
              });
            });
          }
        });
      };
      traverse(this.data.list);
    },
    handleDelete() {
      // 删除已选择
      const traverse = array => {
        array = array.filter((element, index) => {
          if (["grid", "tabs", "selectInputList"].includes(element.type)) {
            // 栅格布局
            element.columns.forEach(item => {
              item.list = traverse(item.list);
            });
          }
          if (element.type === "card" || element.type === "batch" || element.type === 'selectCard' || element.type === 'emptyCard') {
            // 卡片布局
            element.list = traverse(element.list);
          }
          if (element.type === "table") {
            // 表格布局
            element.trs.forEach(item => {
              item.tds.forEach(val => {
                val.list = traverse(val.list);
              });
            });
          }
          if (element.key !== this.selectItem.key) {
            return true;
          } else {
            if (array.length === 1) {
              this.handleSelectItem({ key: "" });
            } else if (array.length - 1 > index) {
              this.handleSelectItem(array[index + 1]);
            } else {
              this.handleSelectItem(array[index - 1]);
            }
            return false;
          }
        });
        return array;
      };

      this.data.list = traverse(this.data.list);
      
      // 重新排序所有项目的序号
      this.updateSequenceNumbers();
    },
 handleDownMerge() {
  const table = this.rightMenuSelectValue;
  const trs = table.trs || [];

  const currentRow = trs[this.trIndex];
  if (!currentRow || !currentRow.tds || !currentRow.tds[this.tdIndex]) {
    message.error("未找到当前单元格");
    return false;
  }

  const currentCell = currentRow.tds[this.tdIndex];

  if (currentCell.rowspan <= 0 || currentCell.colspan <= 0) {
    message.error("当前单元格无法向下合并");
    return false;
  }

  const currentRowspan = Number(currentCell.rowspan) || 1;
  const currentColspan = Number(currentCell.colspan) || 1;
  const targetRowIndex = this.trIndex + currentRowspan;

  if (targetRowIndex >= trs.length) {
    message.error("当前是最后一行，无法向下合并");
    return false;
  }

  const currentColStart = this.getCellStartCol(currentRow.tds, this.tdIndex);
  const targetCellInfo = this.findCellByColStart(
    trs[targetRowIndex].tds,
    currentColStart
  );

  if (!targetCellInfo) {
    message.error("未找到可向下合并的目标单元格");
    return false;
  }

  const { cell: targetCell, index: targetTdIndex } = targetCellInfo;

  if (targetCell.rowspan <= 0 || targetCell.colspan <= 0) {
    message.error("目标单元格不可合并");
    return false;
  }

  if ((Number(targetCell.colspan) || 1) !== currentColspan) {
    message.error("当前表格无法向下合并，列跨度不一致");
    return false;
  }

  const targetRowspan = Number(targetCell.rowspan) || 1;

  // 主单元格扩展高度
  currentCell.rowspan = currentRowspan + targetRowspan;

  // 被合并单元格隐藏，去掉输入框
  targetCell.rowspan = 0;
  targetCell.colspan = 0;
  targetCell.list = [];

  this.$set(trs[this.trIndex].tds, this.tdIndex, { ...currentCell });
  this.$set(trs[targetRowIndex].tds, targetTdIndex, { ...targetCell });

  this.$nextTick(() => {
    this.$forceUpdate();
  });

  return true;
},

getCellStartCol(tds, tdIndex) {
  let colStart = 0;
  for (let i = 0; i < tdIndex; i++) {
    const cell = tds[i] || {};
    colStart += Number(cell.colspan) || 1;
  }
  return colStart;
},

findCellByColStart(tds, targetColStart) {
  let colCursor = 0;

  for (let i = 0; i < tds.length; i++) {
    const cell = tds[i] || {};
    const colspan = Number(cell.colspan) || 1;

    if (colCursor === targetColStart) {
      return {
        cell,
        index: i
      };
    }

    colCursor += colspan;
  }

  return null;
},
    handleRightMerge() {
      // 向右合并
      // 获取当前列的所有colspan总和
      const sumCols = this.rightMenuSelectValue.trs[this.trIndex].tds
        .map(item => item.colspan)
        .reduce(function(partial, value) {
          return partial + value;
        });

      // 判断是否是最后一列，最后一列无法继续向右合并
      if (
        sumCols -
          this.rightMenuSelectValue.trs[this.trIndex].tds[this.tdIndex]
            .colspan <=
        this.tdIndex
      ) {
        message.error("当前是最后一列，无法向右合并");
        return false;
      }

      // 获取当前单元格的colspan
      const currentColspan = this.rightMenuSelectValue.trs[this.trIndex].tds[
        this.tdIndex
      ].colspan;

      // 判断需要合并的单元格rowspan是否与当前单元格一致
      if (
        this.rightMenuSelectValue.trs[this.trIndex].tds[this.tdIndex]
          .rowspan !==
        this.rightMenuSelectValue.trs[this.trIndex].tds[
          this.tdIndex + currentColspan
        ].rowspan
      ) {
        message.error("当前表格无法向右合并");
        return false;
      }

      // 合并单元格colspan
      this.rightMenuSelectValue.trs[this.trIndex].tds[
        this.tdIndex
      ].colspan += this.rightMenuSelectValue.trs[this.trIndex].tds[
        this.tdIndex + currentColspan
      ].colspan;

      // 将被合并的单元格colspan设置为0
      this.rightMenuSelectValue.trs[this.trIndex].tds[
        this.tdIndex + currentColspan
      ].colspan = 0;

      // 情况被合并单元格的list
      this.rightMenuSelectValue.trs[this.trIndex].tds[
        this.tdIndex + currentColspan
      ].list = [];
    },
    handleCancelMerge() {
      // 取消合并单元格
      const currentTd = this.rightMenuSelectValue.trs[this.trIndex].tds[this.tdIndex];
      const colspan = currentTd.colspan || 1;
      const rowspan = currentTd.rowspan || 1;

      if (colspan <= 1 && rowspan <= 1) {
        message.warning("当前单元格未合并");
        return false;
      }

      for (
        let rowIndex = this.trIndex, rowLen = this.trIndex + rowspan;
        rowIndex < rowLen;
        rowIndex++
      ) {
        for (
          let colIndex = this.tdIndex, colLen = this.tdIndex + colspan;
          colIndex < colLen;
          colIndex++
        ) {
          if (rowIndex === this.trIndex && colIndex === this.tdIndex) continue;
          this.rightMenuSelectValue.trs[rowIndex].tds.splice(colIndex, 1, {
            colspan: 1,
            rowspan: 1,
            list: [{
              "type": "input",
              "label": "",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
              "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
              "help": "",
              "rules": [],
              "isChecked": false,
              "isTableCell": true
            }]
          });
        }
      }
      // 修改当前单元格colspan、rowspan为1
      currentTd.colspan = 1;
      currentTd.rowspan = 1;
    },
    handleAddCol() {
      // 增加列
      this.rightMenuSelectValue.trs.forEach(item => {
        // 创建带有输入框的单元格
        const newCell = {
          colspan: 1,
          rowspan: 1,
          list: [{
            "type": "input",
            "label": "",
            "options": {
              "type": "text",
              "width": "100%",
              "defaultValue": "",
              "placeholder": "",
              "clearable": false,
              "showLabel": false,
              "hidden": false,
              "disabled": false
            },
            "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
            "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
            "help": "",
            "rules": [],
            "isChecked": false,
            "isTableCell": true
          }]
        };
        item.tds.splice(this.tdIndex + 1, 0, newCell);
      });
    },
    handleAddRow() {
      // 增加行
      // 获取总col值
      const sumCols = this.rightMenuSelectValue.trs[0].tds
        .map(item => item.colspan)
        .reduce(function(partial, value) {
          return partial + value;
        });
      const rowJson = { tds: [] };
      for (let i = 0; i < sumCols; i++) {
        // 创建带有输入框的单元格
        rowJson.tds.push({
          colspan: 1,
          rowspan: 1,
          list: [{
            "type": "input",
            "label": "",
            "options": {
              "type": "text",
              "width": "100%",
              "defaultValue": "",
              "placeholder": "",
              "clearable": false,
              "showLabel": false,
              "hidden": false,
              "disabled": false
            },
            "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
            "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
            "help": "",
            "rules": [],
            "isChecked": false,
            "isTableCell": true
          }]
        });
      }

      // 取当前rowspan最大值
      let maxRowSpan = 1;
      this.rightMenuSelectValue.trs[this.trIndex].tds.forEach(item => {
        if (maxRowSpan < item.rowspan) {
          maxRowSpan = item.rowspan;
        }
      });

      // 在rowspan最大值处插入数据
      this.rightMenuSelectValue.trs.splice(
        this.trIndex + maxRowSpan,
        0,
        rowJson
      );
    },
    handleDelCol() {
      // 删除当前列
      const sumCols = this.rightMenuSelectValue.trs[0].tds
        .map(item => item.colspan)
        .reduce(function(partial, value) {
          return partial + value;
        });
      if (sumCols <= 1) {
        message.error("最后一列无法删除");
        return false;
      }
      this.rightMenuSelectValue.trs.forEach(item => {
        item.tds.splice(this.tdIndex, 1);
      });
    },
    handleDelRow() {
      // 删除当前行
      if (this.rightMenuSelectValue.trs.length <= 1) {
        message.error("最后一行无法删除");
        return false;
      }
      this.rightMenuSelectValue.trs.splice(this.trIndex, 1);
    },
    handleShowRightMenu(e, val, trIndex, tdIndex) {
      // 显示右键菜单
      e.stopPropagation();
      // this.fileItem = item
      // 显示
      this.showRightMenu = true;

      // 定位
      this.menuTop = e.clientY;
      this.menuLeft = e.clientX;
      // this.rightMenuType = type
      // this.rightId = id
      this.activeArr = [val];
      this.rightMenuSelectValue = val;
      this.trIndex = trIndex;
      this.tdIndex = tdIndex;
      return false;
    },
    refreshOptions() {
      // 刷新数据
      this.$emit("refreshOptions");
    },
    
    handleRelation(record) {
      // 传递打开父子题关系设置弹窗事件给父组件
      if (!record) {
        return;
      }
      this.$emit("handleRelation", record);
    },
    handleRemoveRightMenu() {
      // 取消右键菜单
      this.showRightMenu = false;
    }
  },
  mounted() {
    // 添加监听取消右键菜单
    document.addEventListener("click", this.handleRemoveRightMenu, true);
    document.addEventListener("contextmenu", this.handleRemoveRightMenu, true);
  },
  destroyed() {
    // 移除监听
    document.removeEventListener("click", this.handleRemoveRightMenu, true);
    document.removeEventListener(
      "contextmenu",
      this.handleRemoveRightMenu,
      true
    );
  }
};
</script>